import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function FlightDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const offer = location.state?.offer;

  if (!offer) {
    return (
      <div style={{ padding: '20px' }}>
        <p>Aucune offre sélectionnée.</p>
        <button onClick={() => navigate(-1)}>Retour</button>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>Détails de l'offre de vol</h1>
      <p>
        <strong>Prix total :</strong> {offer.price.total} {offer.price.currency}
      </p>
      <p>
        <strong>Nombre de passagers :</strong> {offer.travelerPricings?.length}
      </p>

      {offer.itineraries.map((itinerary, idx) => (
        <div key={idx} style={{ marginBottom: '30px', padding: '10px', border: '1px solid #ccc', borderRadius: '8px' }}>
          <h2>Itinéraire {idx + 1}</h2>
          <p>
            <strong>Durée totale :</strong> {itinerary.duration}
          </p>
          {itinerary.segments.map((segment, segIdx) => (
            <div key={segIdx} style={{ marginBottom: '15px' }}>
              <h4>Segment {segIdx + 1}</h4>
              <p>
                ✈️ <strong>De :</strong> {segment.departure.iataCode} à {segment.arrival.iataCode}
              </p>
              <p>
                <strong>Départ :</strong> {segment.departure.at}
              </p>
              <p>
                <strong>Arrivée :</strong> {segment.arrival.at}
              </p>
              <p>
                <strong>Durée :</strong> {segment.duration}
              </p>
              <p>
                <strong>Numéro du vol :</strong> {segment.carrierCode} {segment.number}
              </p>
              <p>
                <strong>Compagnie :</strong> {segment.operating?.carrierCode || segment.carrierCode}
              </p>
              {segment.aircraft && (
                <p>
                  <strong>Avion :</strong> {segment.aircraft.code}
                </p>
              )}
              {segment.numberOfStops !== undefined && (
                <p>
                  <strong>Nombre d'escales :</strong> {segment.numberOfStops}
                </p>
              )}
              <hr />
            </div>
          ))}
        </div>
      ))}

      <h2>Détails tarifaires</h2>
      {offer.travelerPricings.map((tp, i) => (
        <div key={i} style={{ marginBottom: '20px' }}>
          <p>
            <strong>Passager {i + 1}</strong> ({tp.travelerType})
          </p>
          <p>
            - Prix : {tp.price.total} {tp.price.currency}
          </p>
          <p>
            - Tarif : {tp.fareDetailsBySegment.map((fd, j) => (
              <span key={j}>
                Segment {j + 1} : cabine {fd.cabin}, classe {fd.class}, base {fd.fareBasis}<br />
              </span>
            ))}
          </p>
        </div>
      ))}

      <button onClick={() => navigate(-1)}>⬅ Retour à la liste</button>
    </div>
  );
}

export default FlightDetails;
